import {call, put, takeLatest} from "redux-saga/effects";
import {TreatmentPlanTemplatesAPI} from "../../../api/treatmentPlansAPI";
import {ToastType} from "../../../utils/interfaces";
import {
  CREATE_MEDICATION_TEMPLATE_ERROR,
  CREATE_MEDICATION_TEMPLATE_REQUEST,
  CREATE_MEDICATION_TEMPLATE_SUCCESS,
  SET_TOAST
} from "../../actions";

function* workerCreateMedicationTemplate(action: {
  type: string;
  payload: {data: any; callback: Function, navigate: Function};
}): Generator<any> {
  try {
    const {data, navigate, callback} = action.payload;
    const response: any = yield call(
      TreatmentPlanTemplatesAPI.createMedicationTemplate,
      data
    );
    yield put({
      type: CREATE_MEDICATION_TEMPLATE_SUCCESS
    });
    callback();
    navigate(`/medication-templates/view/${response.id}`);
    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message: "New Medication Template is added successfully",
        type: ToastType.SUCCESS,
      }
    });
  } catch (error: any) {
    yield put({
      type: CREATE_MEDICATION_TEMPLATE_ERROR,
      payload: {code: error.response.status, message: error.message}
    });

    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message: "An error occurred while updating Medication Template",
        type: ToastType.ERROR,
      }
    });
  }
}

export function* watcherCreateMedicationTemplate() {
  yield takeLatest(
    CREATE_MEDICATION_TEMPLATE_REQUEST,
    workerCreateMedicationTemplate
  );
}
